module.exports = __webpack_public_path__ + "img/male3.8d13342c.jpeg";